/**
 * Andre Garen - EK10 Faz 2 S006 Son baktiklarin yelpazesi. Anahtar S006 (window.agOz).
 * Veri: bu cihazda tutulan son baktigin urunler (localStorage ag:son-bakilan, yalniz handle; urun sayfasinda ag-arama-ek.js yazar);
 * hesapla esitlenmez, sunucuya gitmez. Tetik: alt cubuktaki AG dugmesinden yukari kaydirma ya da menude "Son baktiklarin" satiri
 * (uzun basis kullanilmaz). Davranis: perde koyulasir, altin yay uzerinde en cok 6 kart 240 ms'de acilir; disina dokunmak, asagi
 * kaydirmak, x ya da Esc kapatir; "Temizle" listeyi siler. 2'den az urun varsa acilmaz, satilan urun listeden duser.
 * Hareket azaltmada kartlar animasyonsuz.
 */
(function () {
  'use strict';
  var KEY = 'ag:son-bakilan', D = document.documentElement;
  function oz() { return !!(window.agOz && window.agOz('S006')); }
  function oku() { try { var l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function yazL(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  function sakin() { return D.getAttribute('data-ag-calm') === '1' || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function tl(k) { return new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(k / 100) + ' \u20ba'; }
  var kap = null, acan = null, mesgul = false;
  function kapat() {
    if (!kap) return; var k = kap; kap = null; D.classList.remove('ag-yelpaze-acik');
    k.classList.remove('ag-yelpaze--acik'); setTimeout(function () { k.remove(); }, sakin() ? 0 : 200);
    if (acan && acan.focus) acan.focus({ preventScroll: true });
  }
  function ac(kaynak) {
    if (kap || mesgul || !oz()) return;
    var l = oku().slice(0, 8); if (l.length < 2) return;
    mesgul = true; acan = kaynak || null;
    Promise.all(l.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return undefined; }); })).then(function (ps) {
      mesgul = false;
      var kalan = [], urun = [];
      ps.forEach(function (p, i) { if (p === null) return; if (p && !p.available) return; kalan.push(l[i]); if (p && urun.length < 6) urun.push(p); });
      if (kalan.length !== l.length) yazL(kalan);
      if (urun.length < 2) return;
      kap = document.createElement('div'); kap.className = 'ag-yelpaze'; kap.setAttribute('role', 'dialog'); kap.setAttribute('aria-modal', 'true'); kap.setAttribute('aria-label', 'Son bakt\u0131klar\u0131n');
      var n = urun.length;
      kap.innerHTML = '<div class="ag-yelpaze__perde" data-ag-yelpaze-kapat></div><div class="ag-yelpaze__yay">' +
        '<svg class="ag-yelpaze__cizgi" viewBox="0 0 400 120" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M4 116 Q200 -36 396 116"/></svg>' +
        '<p class="ag-yelpaze__bas">Son bakt\u0131klar\u0131n \u00b7 ' + n + '</p><p class="ag-yelpaze__soz">Kald\u0131\u011f\u0131n yerden devam et.</p><button type="button" class="ag-yelpaze__kapat" data-ag-yelpaze-kapat aria-label="Kapat">\u00d7</button>' +
        '<ul class="ag-yelpaze__kartlar" role="list">' + urun.map(function (p, i) {
          var t = n > 1 ? i / (n - 1) : .5, x = (t - .5) * 2, aci = x * 14, dy = Math.round(x * x * 26);
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
          return '<li class="ag-yelpaze__kart" style="--x:' + (t * 100).toFixed(1) + '%;--a:' + aci.toFixed(1) + 'deg;--dy:' + dy + 'px;--i:' + i + '"><a href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" width="90" height="120" loading="lazy">' : '') + '<span class="ag-yelpaze__ad">' + p.title.replace(/</g, '&lt;') + '</span><span class="ag-yelpaze__fiyat">' + tl(p.price) + '</span></a></li>';
        }).join('') + '</ul><p class="ag-yelpaze__ipucu">Dokun, \u00fcr\u00fcne git</p><button type="button" class="ag-yelpaze__temizle" data-ag-yelpaze-temizle>Temizle</button></div>';
      document.body.appendChild(kap); D.classList.add('ag-yelpaze-acik');
      requestAnimationFrame(function () { if (kap) kap.classList.add('ag-yelpaze--acik'); });
      var ilk = kap.querySelector('.ag-yelpaze__kart a'); if (ilk) ilk.focus({ preventScroll: true });
      kap.addEventListener('click', function (e) {
        if (e.target.closest('[data-ag-yelpaze-kapat]')) { kapat(); return; }
        if (e.target.closest('[data-ag-yelpaze-temizle]')) { yazL([]); kapat(); satir(); }
      });
      var y0 = null;
      kap.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
      kap.addEventListener('touchend', function (e) { if (y0 !== null && e.changedTouches[0].clientY - y0 > 60) kapat(); y0 = null; }, { passive: true });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!kap) return;
    if (e.key === 'Escape') { kapat(); return; }
    if (e.key === 'Tab') { var f = kap.querySelectorAll('a, button'), a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
  });

  /* AG dugmesinden yukari kaydirma (dokunus): gezinme yerine yelpaze */
  var y0 = null, x0 = null, yut = 0;
  document.addEventListener('touchstart', function (e) {
    var h = e.target.closest && e.target.closest('.ag-bb__item--home'); y0 = h ? e.touches[0].clientY : null; x0 = h ? e.touches[0].clientX : null;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (y0 === null) return; var dy = e.changedTouches[0].clientY - y0, dx = e.changedTouches[0].clientX - x0; y0 = null;
    if (dy < -30 && Math.abs(dx) < 40 && oz() && oku().length >= 2) { if (e.cancelable) e.preventDefault(); yut = Date.now(); ac(document.querySelector('.ag-bb__item--home')); }
  }, { passive: false });
  document.addEventListener('click', function (e) { if (Date.now() - yut < 600 && e.target.closest && e.target.closest('.ag-bb__item--home')) { e.preventDefault(); e.stopPropagation(); } }, true);

  /* menude "Son baktiklarin" satiri (2'den az urunde yok) */
  function satir() {
    var var0 = document.querySelector('[data-ag-yelpaze-satir]');
    if (!oz() || oku().length < 2) { if (var0) var0.remove(); return; }
    if (var0) return;
    var ul = document.querySelector('.ag-fullnav__extra .ag-fullnav__mini'); if (!ul) return;
    var li = document.createElement('li'); li.setAttribute('data-ag-yelpaze-satir', '');
    li.innerHTML = '<button type="button" class="ag-fullnav__row ag-fullnav__row--plain ag-yelpaze__menu" aria-haspopup="dialog">Son bakt\u0131klar\u0131n</button>';
    ul.appendChild(li);
    li.firstChild.addEventListener('click', function () { ac(li.firstChild); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', satir); else satir();
  window.AGYelpaze = { ac: ac, kapat: kapat };
})();
